import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList } from "@/mocks/animeData";

const featured = animeList.filter((a) => a.rating >= 9.5).slice(0, 5);

export default function Featured() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-primary-600">
              <i className="ri-fire-fill"></i> Editor's Pick
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">本周热门推荐</h2>
            <p className="mt-2 text-sm text-foreground-600">口碑与热度齐飞，编辑亲手筛选的入坑首选。</p>
          </div>
          <Link
            to="/sousuo"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 sm:inline-flex"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {featured.map((a) => (
            <AnimeCard key={a.id} anime={a} />
          ))}
        </div>
      </div>
    </section>
  );
}